import script from "./motherboard-top5-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./motherboard-top5-chart.vue?vue&type=script&lang=ts&setup=true"

import "./motherboard-top5-chart.vue?vue&type=style&index=0&id=7270d48f&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7270d48f"]])

export default __exports__